import { httpGet, httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../../constants/external-constants';
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

import {
    getOutputConfiguration,
    setDefaultOutputConfiguration,
    setOutputConfigurationError,
    setOutputConfigurationColSearchStr,
    sortOutputConfigurationItems,
    setOutputConfigurationPageSize,
    setOutputConfigurationFilter,
    applyOutputConfigurationFilter
} from "../../../../constants/model-reducers/external/recharge/output-configuration/output-configuration.settings";

const defaultState = () => ({
    isOutputConfigurationLoaded: false,
    isOutputConfigurationError: false,
    outputConfigurationItems: DEFAULT_TABLE_RESULT_MODEL,
    outputConfigurationColSort: '',
    outputConfigurationIsSortedAsc: false,
    outputConfigurationFilterData: [],
    outputConfigurationFilterLoaded: false,
    outputConfigurationTableFilterList: [],
    outputConfigurationTableFilterApply: false
});

const initialState = defaultState();

export const outputConfigurationActions = {
    setDefaultOutputConfiguration: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultOutputConfiguration,
            outputConfigurationItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },

    getOutputConfiguration: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().outputConfiguration.outputConfigurationItems;
        const { outputConfigurationColSort, outputConfigurationIsSortedAsc, outputConfigurationTableFilterList, outputConfigurationTableFilterApply } = state().outputConfiguration;

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: outputConfigurationColSort,
                IsSortAscending: outputConfigurationIsSortedAsc,
                TableFilterList: outputConfigurationTableFilterList,
                ApplyFilter: outputConfigurationTableFilterApply
            };

            var outputConfigurationItems = await httpPost('external/recharge/getOutputConfigurationItems', data);

            dispatch({
                type: getOutputConfiguration,
                outputConfigurationItems: Object.keys(outputConfigurationItems).length > 0 ? outputConfigurationItems : DEFAULT_TABLE_RESULT_MODEL,
                isOutputConfigurationLoaded: true,
                isOutputConfigurationError: false
            });
        }
        catch (e) {
            dispatch({
                type: setOutputConfigurationError,
                isOutputConfigurationError: true,
                isOutputConfigurationLoaded: false
            })
        }
    },

    extractOutputConfiguration: () => async (dispatch, state) => {
        const { Headers } = state().outputConfiguration.outputConfigurationItems;
        const { outputConfigurationColSort, outputConfigurationIsSortedAsc, outputConfigurationTableFilterApply, outputConfigurationTableFilterList } = state().outputConfiguration;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Output Configuration Extract – ${formattedTimeZoneDate}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: outputConfigurationColSort,
            IsSortAscending: outputConfigurationIsSortedAsc,
            TableFilterList: outputConfigurationTableFilterList,
            ApplyFilter: outputConfigurationTableFilterApply,
        };

        httpDownload('external/recharge/getAllOutputConfigurationExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setOutputConfigurationColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { outputConfigurationItems } = state().outputConfiguration;
        var outputConfigurationListUpd = {
            ...outputConfigurationItems,
            "Headers": {
                ...outputConfigurationItems.Headers,
                [key]: {
                    ...outputConfigurationItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setOutputConfigurationColSearchStr,
            data: outputConfigurationListUpd,
            isOutputConfigurationLoaded: true,
            isOutputConfigurationError: false
        });
    },

    sortOutputConfigurationItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().outputConfiguration.outputConfigurationItems.Pagination;
        const { outputConfigurationItems, outputConfigurationTableFilterList, outputConfigurationTableFilterApply } = state().outputConfiguration;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: outputConfigurationItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...outputConfigurationItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: outputConfigurationTableFilterList,
            ApplyFilter: outputConfigurationTableFilterApply
        };

        var resOutputConfigurationList = await httpPost('external/recharge/getOutputConfigurationItems', data);
        if (resOutputConfigurationList.ok === false) {
            dispatch({
                type: setOutputConfigurationError,
                isOutputConfigurationError: true,
                isOutputConfigurationLoaded: false
            });
        } else {
            dispatch({
                type: sortOutputConfigurationItems,
                outputConfigurationItems: Object.keys(resOutputConfigurationList).length > 0 ? resOutputConfigurationList : DEFAULT_TABLE_RESULT_MODEL,
                outputConfigurationColSort: columnClicked,
                outputConfigurationIsSortedAsc: isSortedAsc,
                isOutputConfigurationLoaded: true
            })
        }
    },

    resizeOutputConfigurationPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setOutputConfigurationPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    saveOutputConfigurationCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().outputConfiguration.outputConfigurationItems;
        const { outputConfigurationColSort, outputConfigurationIsSortedAsc } = state().outputConfiguration;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.OutputConfigurationRechargeManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/recharge/saveOutputConfigurationCustomizeColumns', customizeFormData)
            dispatch({
                type: setOutputConfigurationError,
                isOutputConfigurationError: false,
                isOutputConfigurationLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: outputConfigurationColSort,
                IsSortAscending: outputConfigurationIsSortedAsc
            };

            var outputConfigurationItems = await httpPost('external/recharge/getOutputConfigurationItems', data);

            dispatch({
                type: getOutputConfiguration,
                outputConfigurationItems: Object.keys(outputConfigurationItems).length > 0 ? outputConfigurationItems : DEFAULT_TABLE_RESULT_MODEL,
                isOutputConfigurationLoaded: true,
                isOutputConfigurationError: false
            });
        }
        catch (e) {
            dispatch({
                type: setOutputConfigurationError,
                isOutputConfigurationError: true,
                isOutputConfigurationLoaded: false
            });
        }
    },

    addOutputConfigurationFilter: (tableFilter) => (dispatch, state) => {
        const { outputConfigurationTableFilterList } = state().outputConfiguration;
        var filterList = [...outputConfigurationTableFilterList, tableFilter];

        dispatch({
            type: setOutputConfigurationFilter,
            filterList: filterList
        })
    },

    removeOutputConfigurationFilter: (removeIndex) => (dispatch, state) => {
        const { outputConfigurationTableFilterList } = state().outputConfiguration;

        var filterList = outputConfigurationTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setOutputConfigurationFilter,
            filterList: filterList
        })
    },

    applyOutputConfigurationFilter: (isApply) => (dispatch, state) => {
        const { outputConfigurationTableFilterList } = state().outputConfiguration;

        dispatch({
            type: applyOutputConfigurationFilter,
            applyFilter: isApply,
            filterList: isApply ? outputConfigurationTableFilterList : []
        });
    },

    getCurrentInProgressOutputRecordConfigurationName: () => async (dispatch, state) => {
        try {
            const { configurationName } = await httpGet('external/recharge/getCurrentInProgressOutputRecordConfigurationName');
            return configurationName ?? "";
        } catch (error) {
            console.error("Error fetching configuration name:", error);
            return ""; // fail gracefully
        }
    },

    getCurrentInProgressOutputRecordConfigurationNumber: () => async (dispatch, state) => {
        try {
            const { configurationNumber } = await httpGet('external/recharge/getCurrentInProgressOutputRecordConfigurationNumber');
            return configurationNumber ?? 0;
        } catch (error) {
            console.error("Error fetching configuration number:", error);
            return ""; // fail gracefully
        }
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getOutputConfiguration:
            return {
                ...state,
                outputConfigurationItems: action.outputConfigurationItems,
                isOutputConfigurationLoaded: action.isOutputConfigurationLoaded,
                isOutputConfigurationError: action.isOutputConfigurationError
            };
        case setOutputConfigurationError:
            return {
                ...state,
                isOutputConfigurationLoaded: action.isOutputConfigurationLoaded,
                isOutputConfigurationError: action.isOutputConfigurationError
            };
        case setOutputConfigurationColSearchStr:
            return {
                ...state,
                outputConfigurationItems: action.data,
                isOutputConfigurationLoaded: action.isOutputConfigurationLoaded,
                isOutputConfigurationError: action.isOutputConfigurationError
            };
        case sortOutputConfigurationItems:
            return {
                ...state,
                outputConfigurationItems: action.outputConfigurationItems,
                outputConfigurationColSort: action.outputConfigurationColSort,
                outputConfigurationIsSortedAsc: action.outputConfigurationIsSortedAsc,
                isOutputConfigurationLoaded: action.isOutputConfigurationLoaded
            };
        case setOutputConfigurationPageSize:
            return {
                ...state,
                outputConfigurationItems: {
                    ...state.outputConfigurationItems,
                    Pagination: {
                        ...state.outputConfigurationItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setOutputConfigurationFilter:
            return {
                ...state,
                outputConfigurationTableFilterList: action.filterList,
            };
        case applyOutputConfigurationFilter:
            return {
                ...state,
                outputConfigurationTableFilterApply: action.applyFilter,
                outputConfigurationTableFilterList: action.filterList
            };
        case setDefaultOutputConfiguration:
            return initialState;
        default:
            return state;
    }
}